module.exports = __webpack_public_path__ + "static/media/battery-grey.1a27e0ae.svg";